module.exports = __webpack_public_path__ + "static/media/sg12cr1023.6b910a14.png";